import React, { ReactNode } from "react";
import { StatementListItem } from "../../firebase/statements";
import StatementLink from "../shared/StatementLink";
import Spinner from "../shared/Spinner";
import { useTranslation } from "react-i18next";
import { initStatementNavigation } from "../statements/statementNavigation";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
import Button from "../shared/Button";

const useStyles = makeStyles((theme) => ({
  listContainer: {
    paddingBottom: "50px",
    // [theme.breakpoints.down("xs")]: {
    //   paddingBottom: "10px",
    // },
    // [theme.breakpoints.down("sm")]: {
    //  
    // },
  },
  container: {
    borderRadius: "3px",
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.16)",
    backgroundColor: colors.BACKGROUND_SECONDARY,
    paddingBottom: "13px",
    paddingTop: "13px"
  },
  statementContainer: {
    paddingLeft: "24px",
    [theme.breakpoints.down("xs")]: {
      paddingBottom: "3px",
    },
    [theme.breakpoints.up("sm")]: {
      paddingBottom: "10px",
    },
  },
  statementTitle: {
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.67,
    letterSpacing: "-0.05px",
    color: colors.TEXT_PRIMARY,
    "&:hover": {},
  },
  statementObject: {
    paddingLeft: "24px",
  },
  textOverflow: {
    [theme.breakpoints.down("xs")]: {
      maxWidth: "250px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
  },
  buttonContainer: {
    paddingLeft: "32px",
    paddingRight: "32px",
    [theme.breakpoints.down("xs")]: {
      padding: "0px",
    },
  },
  viewButton: {
    [theme.breakpoints.down("xs")]: {
      width: "66px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
  },
  noRecords: {
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.67,
    paddingLeft: "24px",
    margin: "0px",
  },
  noStatements: {
    width: "100%",
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "bold",
    paddingBottom: "20px"
  }
}));

export type StatusType =
  | "idle"
  | "loading"
  | "done"
  | "nothing_found"
  | "nothing_found_for_filter";

export default function StatementsList({
  statements,
  status,
  children,
}: {
  statements: StatementListItem[];
  status: StatusType;
  children: ReactNode;
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  function handleStatementClick() {
    initStatementNavigation(statements.map((s) => s.slug));
  }

  if (status === "idle") return null;

  if (status === "loading") return <Spinner isVisible={true} />;

  return (
    <Grid container item direction="column" className={classes.listContainer}>
      <Grid container item direction="column">
        {children}
        <Grid item className={classes.noStatements}>
          {status === "nothing_found" && (
            <>{t("dashboard_statements.nothingfound")}</>
          )}
          {status === "nothing_found_for_filter" && (
            <>{t("dashboard_statements.region_nostatements")}</>
          )}
        </Grid>
        <Grid container item spacing={2} className={classes.container}>
          {statements && statements.length > 0 && statements.map((statement) => (
            <Grid
              container
              item
              justify="space-between"
              className={classes.statementContainer}
              key={statement.id}
            >
              <Grid className={classes.statementObject} item xs={10} key={statement.id}>
                <div className={classes.textOverflow}>
                  <StatementLink
                    slug={statement.slug}
                    className={classes.statementTitle}
                    onClick={handleStatementClick}
                  >
                    {statement.title}
                  </StatementLink>
                </div>
              </Grid>
              <Grid className={classes.buttonContainer} item xs={2}>
                <Button
                  linkTo={statement.slug}
                  className={classes.viewButton}
                  onClick={handleStatementClick}
                >
                  View
                </Button>
              </Grid>
            </Grid>
          ))}
          {statements && statements.length === 0 && (
            <Grid
              container
              item
              justify="space-between"
              className={classes.statementContainer}
            >
            <Grid item xs={10}>
              <div className={classes.textOverflow}>
                <p className={classes.noRecords}>{t("dashboard_statements.nostatements")}</p>
              </div>
            </Grid>
            <Grid item xs={2} />
          </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
